import { computed } from 'vue'
import type { ComputedRef, Ref } from 'vue'
import type { StrapiHeader, StrapiSingleResponse } from '@ts-strapi/interfaces'
import { useStrapiFetch } from '@api/strapi/use-strapi-fetch.hook'

interface UseStrapiHeaderReturn {
  refHeader: ComputedRef<StrapiHeader | null>
  refPending: Ref<boolean>
  refError: Ref<Error | null>
  refresh: () => Promise<void>
}

export const useStrapiHeader = async (): Promise<UseStrapiHeaderReturn> => {
  const strapiFetch = useStrapiFetch()

  const { data, pending, error, refresh } = await useAsyncData(
    'strapi:header',
    () => strapiFetch<StrapiSingleResponse<StrapiHeader>>('/header', {
      params: {
        'populate[logo]': 'true',
        'populate[logoMobile]': 'true',
        'populate[primaryButton]': 'true',
        'populate[secondaryButton]': 'true',
        'populate[topItems][on][header.simple-link][populate]': '*',
        'populate[topItems][on][header.multiple-menu][populate][columns][populate]': '*',
        'populate[topItems][on][header.multiple-menu][populate][seeAllLink]': 'true',
        'populate[topItems][on][header.multiple-menu][populate][programLinks]': 'true',
        'populate[topItems][on][header.single-menu][populate][blocks][populate]': '*',
      },
    }),
  )

  return {
    refHeader: computed(() => data.value?.data ?? null),
    refPending: pending,
    refError: error as Ref<Error | null>,
    refresh: () => refresh(),
  }
}
